export default function ({ store, redirect }) {
  // redirect if the user is already signed in
  if (store.getters['session/isAuthenticated']) {
    // redirect to home
    return redirect('/')
  }
}
